import { motion } from 'framer-motion'

interface NotificationBadgeProps {
  count: number
  max?: number
  size?: 'sm' | 'md'
  className?: string
}

const NotificationBadge = ({ count, max = 99, size = 'sm', className = '' }: NotificationBadgeProps) => {
  const value = count ?? 0
  const displayCount = value > max ? `${max}+` : String(value)

  const sizeClasses = size === 'sm'
    ? 'min-w-[18px] h-[18px] text-[10px] px-1'
    : 'min-w-[22px] h-[22px] text-xs px-1.5'

  return (
    <motion.span
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      className={`inline-flex items-center justify-center rounded-full bg-noe-brand text-white font-bold ${sizeClasses} ${className}`}
    >
      {displayCount}
    </motion.span>
  )
}

export default NotificationBadge
